import { CURRENT_HOST_ID } from 'src/app/core/host-identification/current-host-id';

import { SETTINGS } from './settings';
import type { Settings } from './settings.interface';

const currentSettings = SETTINGS.get(CURRENT_HOST_ID);
if (!currentSettings) throw new Error('could not get CURRENT_SETTINGS');

export const CURRENT_SETTINGS: Settings = currentSettings;
